<!-- Modal Header -->
<div class="modal-header border-0 pb-2">
  <div class="d-flex align-items-center flex-grow-1">
    <div class="create-organization-icon me-3">
      <i class="bi bi-building-add"></i>
    </div>
    <div>
      <h4 class="modal-title mb-1">เพิ่มหน่วยงานใหม่</h4>
      <p class="text-muted mb-0 small">เพิ่มข้อมูลหน่วยงานเข้าสู่ระบบ VAT</p>
    </div>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>

<!-- Progress Bar -->
<div class="modal-progress">
  <div class="progress">
    <div class="progress-bar bg-primary" 
         role="progressbar" 
         [style.width.%]="getProgressPercentage()"
         [attr.aria-valuenow]="getProgressPercentage()"
         aria-valuemin="0" 
         aria-valuemax="100">
    </div>
  </div>
  <div class="progress-steps">
    <div class="step-container">
      <div *ngFor="let step of [1, 2, 3]" class="step-item">
        <div class="step-circle" 
             [class.completed]="isStepCompleted(step)"
             [class.current]="isStepCurrent(step)"
             [class.clickable]="step <= currentStep"
             (click)="goToStep(step)">
          <i *ngIf="isStepCompleted(step)" class="bi bi-check-lg"></i>
          <i *ngIf="isStepCurrent(step)" class="{{ getStepIcon(step) }}"></i>
          <span *ngIf="!isStepCompleted(step) && !isStepCurrent(step)">{{ step }}</span>
        </div>
        <div class="step-label">{{ getStepTitle(step) }}</div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form [formGroup]="createOrganizationForm" (ngSubmit)="onSubmit()">
    
    <!-- Step 1: Organization Information -->
    <div class="step-content" *ngIf="currentStep === 1">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-building me-2"></i>ข้อมูลหน่วยงาน
        </h5>
        <p class="step-description">กรอกข้อมูลพื้นฐานของหน่วยงาน</p>
      </div>

      <div class="row">
        <!-- Organization Name -->
        <div class="col-12 mb-3">
          <label class="form-label">ชื่อหน่วยงาน</label>
          <input type="text" 
                 class="form-control" 
                 formControlName="organizationName"
                 [class.is-invalid]="hasError('organizationName')"
                 placeholder="">
          <div class="invalid-feedback" *ngIf="hasError('organizationName')">
            {{ getErrorMessage('organizationName') }}
          </div>
        </div>

        <!-- Organization Type -->
        <div class="col-12 mb-3">
          <label class="form-label">ประเภทหน่วยงาน**</label>
          <select class="form-select" 
                  formControlName="organizationType"
                  [class.is-invalid]="hasError('organizationType')">
            <option value="">เลือกประเภทหน่วยงาน</option>
            <option value="บริษัทประเมินมูลค่าทรัพย์สิน">บริษัทประเมินมูลค่าทรัพย์สิน</option>
            <option value="ธนาคาร/สถาบันการเงิน">ธนาคาร/สถาบันการเงิน</option>
            <option value="หน่วยงานราชการ">หน่วยงานราชการ</option>
            <option value="อื่นๆ">อื่นๆ</option>
          </select>
          <div class="invalid-feedback" *ngIf="hasError('organizationType')">
            {{ getErrorMessage('organizationType') }}
          </div>
        </div>

        <!-- Office Phone Number -->
        <div class="col-12 mb-3">
          <label class="form-label">เบอร์โทรศัพท์สำนักงานใหญ่**</label>
          <input type="text" 
                 class="form-control" 
                 formControlName="officePhone"
                 [class.is-invalid]="hasError('officePhone')"
                 placeholder="">
          <div class="invalid-feedback" *ngIf="hasError('officePhone')">
            {{ getErrorMessage('officePhone') }}
          </div>
        </div>

        <!-- Mobile Phone Number -->
        <div class="col-12 mb-3">
          <label class="form-label">เบอร์โทรศัพท์มือถือ</label>
          <input type="text" 
                 class="form-control" 
                 formControlName="mobilePhone"
                 [class.is-invalid]="hasError('mobilePhone')"
                 placeholder="">
          <div class="invalid-feedback" *ngIf="hasError('mobilePhone')">
            {{ getErrorMessage('mobilePhone') }}
          </div>
        </div>

        <!-- Email -->
        <div class="col-12 mb-3">
          <label class="form-label">อีเมล**</label>
          <input type="email" 
                 class="form-control" 
                 formControlName="email"
                 [class.is-invalid]="hasError('email')"
                 placeholder="">
          <div class="invalid-feedback" *ngIf="hasError('email')">
            {{ getErrorMessage('email') }}
          </div>
        </div>

        <!-- LINE ID -->
        <div class="col-12 mb-3">
          <label class="form-label">LINE ID</label>
          <input type="text" 
                 class="form-control" 
                 formControlName="lineId"
                 placeholder="">
        </div>

        <!-- Website -->
        <div class="col-12 mb-3">
          <label class="form-label">เว็บไซต์</label>
          <input type="url" 
                 class="form-control" 
                 formControlName="website"
                 placeholder="">
        </div>
      </div>
    </div>

    <!-- Step 2: License Information -->
    <div class="step-content" *ngIf="currentStep === 2">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-card-checklist me-2"></i>ใบอนุญาต
        </h5>
        <p class="step-description">กรอกข้อมูลใบอนุญาตและรายละเอียดสำหรับออกใบกำกับภาษี</p>
      </div>

      <div class="row">
        <!-- License Section -->
        <div class="col-12 mb-4">
          <div class="card border-primary">
            <div class="card-header bg-primary text-white">
              <h6 class="mb-0">
                <i class="bi bi-card-checklist me-2"></i>รายละเอียดสำหรับออกใบกำกับภาษี
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12 mb-3">
                  <label class="form-label">เลขประจำตัวผู้เสียภาษี</label>
                  <input type="text" 
                         class="form-control" 
                         formControlName="taxId"
                         [class.is-invalid]="hasError('taxId')"
                         placeholder="">
                  <div class="invalid-feedback" *ngIf="hasError('taxId')">
                    {{ getErrorMessage('taxId') }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">บ้านเลขที่ (สำนักงานใหญ่)</label>
                  <input type="text" 
                         class="form-control" 
                         formControlName="headOfficeAddress"
                         [class.is-invalid]="hasError('headOfficeAddress')"
                         placeholder="">
                  <div class="invalid-feedback" *ngIf="hasError('headOfficeAddress')">
                    {{ getErrorMessage('headOfficeAddress') }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">ชื่อโครงการ/ชื่ออาคาร</label>
                  <input type="text" 
                         class="form-control" 
                         formControlName="projectName"
                         placeholder="">
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">ซอย</label>
                  <input type="text" 
                         class="form-control" 
                         formControlName="taxSoi"
                         placeholder="">
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">ถนน</label>
                  <input type="text" 
                         class="form-control" 
                         formControlName="taxRoad"
                         placeholder="">
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">ตำบล/แขวง</label>
                  <input type="text" 
                         class="form-control" 
                         formControlName="taxSubdistrict"
                         [class.is-invalid]="hasError('taxSubdistrict')"
                         placeholder="">
                  <div class="invalid-feedback" *ngIf="hasError('taxSubdistrict')">
                    {{ getErrorMessage('taxSubdistrict') }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">อำเภอ/เขต</label>
                  <input type="text" 
                         class="form-control" 
                         formControlName="taxDistrict"
                         [class.is-invalid]="hasError('taxDistrict')"
                         placeholder="">
                  <div class="invalid-feedback" *ngIf="hasError('taxDistrict')">
                    {{ getErrorMessage('taxDistrict') }}
                  </div>
                </div>
                <div class="col-12 mb-3">
                  <label class="form-label">จังหวัด</label>
                  <input type="text" 
                         class="form-control" 
                         formControlName="taxProvince"
                         [class.is-invalid]="hasError('taxProvince')"
                         placeholder="">
                  <div class="invalid-feedback" *ngIf="hasError('taxProvince')">
                    {{ getErrorMessage('taxProvince') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Step 3: Admin Management -->
    <div class="step-content" *ngIf="currentStep === 3">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-shield-check me-2"></i>การจัดการของ ADMIN
        </h5>
        <p class="step-description">กำหนดสิทธิ์และการจัดการระบบ</p>
      </div>

      <div class="row">
        <!-- Admin Rights Section -->
        <div class="col-12 mb-3">
          <div class="card border-warning">
            <div class="card-header bg-warning text-dark">
              <h6 class="mb-0">
                <i class="bi bi-shield-check me-2"></i>ส่วนการจัดการของ ADMIN
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12 mb-3">
                  <label class="form-label">สถานะสมาชิกสมทบ (สมาชิกประเภทนิติบุคคล)</label>
                  <select class="form-select" 
                          formControlName="adminRights"
                          [class.is-invalid]="hasError('adminRights')">
                    <option value="yes">YES</option>
                    <option value="no">NO</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="hasError('adminRights')">
                    {{ getErrorMessage('adminRights') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <div class="d-flex justify-content-between w-100">
    <button type="button" 
            class="btn btn-secondary" 
            (click)="prevStep()"
            [disabled]="currentStep === 1">
      <i class="bi bi-arrow-left me-1"></i>ย้อนกลับ
    </button>
    
    <div class="d-flex gap-2">
      <button type="button" 
              class="btn btn-outline-secondary" 
              (click)="close()">
        ยกเลิก
      </button>
      
      <button type="button" 
              class="btn btn-success" 
              (click)="nextStep()"
              *ngIf="currentStep < totalSteps"
              [disabled]="isSubmitting">
        ถัดไป<i class="bi bi-arrow-right ms-1"></i>
      </button>
      
      <button type="submit" 
              class="btn btn-success" 
              *ngIf="currentStep === totalSteps"
              [disabled]="isSubmitting || createOrganizationForm.invalid"
              (click)="onSubmit()">
        <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status"></span>
        <i *ngIf="!isSubmitting" class="bi bi-check-circle me-1"></i>
        {{ isSubmitting ? 'กำลังบันทึก...' : 'บันทึก' }}
      </button>
    </div>
  </div>
</div>
